import React from 'react';
import Link from 'next/link';

import * as ST from './styled';

interface ICrumb {
    name: string,
    url: string,
    as: string,
    rel?: string,
}

export interface IProps {
    items: Array<ICrumb>,
}

export const Crumbs: React.FC<IProps> = ({ items }) => {
    return (
        <ST.Crumbs>
            {items.map((item, ind) => {
                return (
                    <ST.CrumbsWrap key={ind}>
                    {!!ind && <ST.CrumbsSeparate>/</ST.CrumbsSeparate>}
                    <Link
                        href={item.url}
                        as={item.as}
                        passHref
                    >
                        <ST.CrumbElem
                            isDisabled={!item.url}
                            rel={item.rel}
                        >
                            {item.name}
                        </ST.CrumbElem>
                    </Link>
                    </ST.CrumbsWrap>
                );
            })}
        </ST.Crumbs>
    );
};
